/**
 *  ==========================
 *  BLOCK: Icon Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
    disabledBlocks, i18n
    } from 'cartzillagb'
import { applyFilters } from '@wordpress/hooks'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { ButtonIcon } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'

export const schema = {
    limit: {
        type: 'number',
        default: 2,
    },
}

const MaxListlimit = applyFilters( 'cartzillagb.market-button.limit.edit.inspector.max.limit', 4 )

{ range( 1, MaxListlimit + 1 ).map( i => {
    schema[ `pretitle${ i }` ] = {
        type: 'string',
    }
    schema[ `title${ i }` ] = {
        type: 'string',
    }
    schema[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema[ `icon${ i }` ] = {
        type: 'string',
    }
    schema[ `link${ i }` ] = {
        type: 'string',
    }
    return ""
} ) }

export const name = 'czgb/market-button'

export const settings = {
    title: __( 'App Market Buttons', i18n ),
    description: __( 'Create app market buttons to link to app marketplaces like App Store, Google Play, Windows and Amazon.', i18n ),
    icon: ButtonIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'App Market Buttons', i18n ),
        __( 'CartzillaGB', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}
